import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const AnonymousAvatar: React.FC = () => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s16">
      <Box
        borderRadius={{
          all: 'rel333',
        }}
        width="s32"
        height="s32"
        alignItems="center"
        justifyContent="center"
        background={'grey300'}
      >
        <Icon.Medium icon="person" color="grey800" />
      </Box>

      <Text.Normal weight="medium">
        {i18n.t('performance_process.reviews.evaluations.anonymous')}
      </Text.Normal>
    </Box>
  )
}
